import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  chip: {
    margin: '10px 10px 10px 10px',
  },
  subtitle: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px', margin:'5px',
  },
  spacing: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between' , margin:'5px',
  },
}));